import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import dayjs from 'dayjs';

const firebaseRef = firebase.database();

export default function extendCoolingPeriod(coolingPeriodEnd, leadId, days) {
	var leadRef = firebaseRef.ref(
		'/kavtek_agreements/' +
			PROJECT_CODE.projectCode +
			'/' +
			leadId +
			'/documentInformation'
	);

	var newCoolingPeriodEnd = dayjs(coolingPeriodEnd).add(days, 'day');

	leadRef.update({
		coolingPeriodEnd: dayjs(newCoolingPeriodEnd).unix() * 1000,
	});
}
